import RebateDetail from './rebate_detail.vue';

export default RebateDetail;
